import React, { useState } from "react";

interface ImageWithSpinnerProps {
  src: string;
  alt?: string;
  className?: string;
  width?: number | string;
  height?: number | string;
}

const ImageWithSpinner: React.FC<ImageWithSpinnerProps> = ({
  src,
  alt = "",
  className,
  width = 144,
  height = 144,
}) => {
  const [loading, setLoading] = useState(true);

  return (
    <div style={{ position: "relative", width, height }}>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
          }}
        >
          {/* Simple spinner, replace with your spinner component if needed */}
          <div className="spinner" />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        style={
          loading ? { opacity: 0 } : { opacity: 1, transition: "opacity 0.3s" }
        }
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
        width={width}
        height={height}
      />
    </div>
  );
};

export default ImageWithSpinner;
